import { type ReactNode, useEffect, useRef } from 'react'

export function VideoJumbo({
	isIntersectingContent,
	srcMobile,
	srcDesktop,
	children,
}: {
	isIntersectingContent: boolean
	srcMobile: string
	srcDesktop: string
	children?: ReactNode
}) {
	const videoReference = useRef<HTMLVideoElement>(null)

	useEffect(() => {
		// If the content is intersecting, we pause the video.
		if (isIntersectingContent) {
			videoReference.current?.pause()
		}
		// If the content is not intersecting, we play the video.
		else {
			void videoReference.current?.play()
		}
	}, [isIntersectingContent])

	return (
		<div className="relative h-full w-full">
			{/* Native browser solution: browser picks the right source based on media query */}
			<video
				ref={videoReference}
				controls={false}
				loop
				muted
				autoPlay
				playsInline
				preload="auto"
				className="inset-0 z-0 h-screen w-full object-cover"
			>
				<source src={srcMobile} type="video/mp4" media="(max-width: 1023px)" />
				<source src={srcDesktop} type="video/mp4" media="(min-width: 1024px)" />
			</video>

			{children}
		</div>
	)
}
